import React from 'react';
import { Button, Tooltip } from 'antd';
import { BugOutlined } from '@ant-design/icons';

const IssueReporterButton = ({ onClick, theme }) => {
  return (
    <Tooltip title="Report an issue with this API response">
      <Button
        type="dashed"
        danger
        icon={<BugOutlined />}
        onClick={onClick}
        style={{
          borderColor: theme.error,
          color: theme.error,
          backgroundColor: `${theme.error}10`,
          marginTop: '12px'
        }}
        onMouseEnter={(e) => {
          e.currentTarget.style.backgroundColor = `${theme.error}20`;
          e.currentTarget.style.borderColor = theme.error;
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.backgroundColor = `${theme.error}10`;
          e.currentTarget.style.borderColor = theme.error;
        }}
      >
        Report Issue
      </Button>
    </Tooltip>
  );
};

export default IssueReporterButton;